export function Logo({ size = 26 }: { size?: number }) {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
      <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden>
        <defs>
          <linearGradient id="laddr-g" x1="0" y1="32" x2="32" y2="0">
            <stop offset="0" stopColor="#16b89a" />
            <stop offset="1" stopColor="#3df2c4" />
          </linearGradient>
        </defs>
        <rect width="32" height="32" rx="7" fill="#0f131c" stroke="#232b39" />
        {/* ascending ladder rungs */}
        <rect x="7" y="21" width="13" height="2.6" rx="1.3" fill="url(#laddr-g)" />
        <rect x="9.5" y="15.5" width="13" height="2.6" rx="1.3" fill="url(#laddr-g)" />
        <rect x="12" y="10" width="13" height="2.6" rx="1.3" fill="#ffce5c" />
        {/* climbing arrow */}
        <path d="M22 9 L25.5 5.5 L25.5 9.5" stroke="#ffce5c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      </svg>
      <span
        style={{
          fontFamily: "var(--font-display)",
          fontWeight: 600,
          fontSize: size * 0.74,
          letterSpacing: "-0.03em",
        }}
      >
        Laddr<span style={{ color: "var(--mint)" }}>.</span>
      </span>
    </span>
  );
}
